import { render } from "./TouchesView.vue?vue&type=template&id=1308f79c&scoped=true"
import script from "./TouchesView.vue?vue&type=script&lang=js"
export * from "./TouchesView.vue?vue&type=script&lang=js"

import "./TouchesView.vue?vue&type=style&index=0&id=1308f79c&lang=css"
import "./TouchesView.vue?vue&type=style&index=1&id=1308f79c&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1308f79c"]])

export default __exports__